<section fxLayoutAlign="end center">
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</section>

<section *ngIf="directSub$ | async as sub" fxFlexFill fxLayout fxLayoutAlign="center center">
  <div *ngIf="!loading" class="fs-dialog-contents">
    <h1>Activate {{ sub.plan | directSubscriptionDescriptionFromKey }}</h1>

    <div fxLayout="column" fxLayoutGap="12px">
      <sbnb-direct-plan-grid-item>
        Once you activate Direct, you will be charged monthly for each unique property published on any Direct site or
        booking widget.
      </sbnb-direct-plan-grid-item>

      <sbnb-direct-plan-grid-item *ngIf="sub.active_direct_properties > 0">
        If you activate Direct Premium an additional fee of
        <strong>{{ sub.charge_amount }}</strong>
        for
        <strong>{{ sub.active_direct_properties }}</strong>
        properties will appear on your next {{ 'CORE.PRODUCT_NAME' | transloco }} invoice on
        <strong>{{ sub.next_charge_date | date }}</strong>
        .
      </sbnb-direct-plan-grid-item>

      <sbnb-direct-plan-grid-item *ngIf="sub.active_direct_properties === 0">
        Add properties to your Direct sites or booking widgets to see how much Direct will cost. Or
        <a
          class="link"
          target="_blank"
          href="https://my.hospitable.com/support-documentation/article/5845339-all-about-direct-bookings">
          Learn more about Direct pricing
        </a>
        .
      </sbnb-direct-plan-grid-item>

      <sbnb-direct-plan-grid-item *ngIf="needsToAddAdyenAccount || needsToAddStripeAccount">
        You'll need to add a payout method before we can activate Direct, to ensure that you can get paid for your
        Direct bookings.
      </sbnb-direct-plan-grid-item>
    </div>

    <div class="direct-subscription-actions-container">
      <sbnb-button
        *ngIf="!needsToAddAdyenAccount && !needsToAddStripeAccount"
        (clicked)="activatePlan()"
        [loading]="activatingPlan">
        Activate {{ sub.plan | directSubscriptionDescriptionFromKey }}
      </sbnb-button>

      <ng-container *ngIf="needsToAddAdyenAccount">
        <sbnb-button
          [routerLink]="['/direct/payouts/new/adyen']"
          [queryParams]="{ redirect: 'activate' }"
          (clicked)="dialogRef.close()"
          type="primary-teal">
          Add a payout method
        </sbnb-button>
        <span class="card__collapsed-helper-text">A payout method is required to activate Direct Premium.</span>
      </ng-container>

      <ng-container *ngIf="needsToAddStripeAccount">
        <sbnb-button
          [routerLink]="['/direct/payouts/new/stripe-oauth']"
          [queryParams]="{ redirect: 'activate' }"
          (clicked)="dialogRef.close()"
          type="primary-teal">
          Add a Stripe account
        </sbnb-button>
        <span class="card__collapsed-helper-text">A payout method is required to activate Direct Basic.</span>
      </ng-container>
    </div>
  </div>

  <mat-spinner *ngIf="loading" diameter="32"></mat-spinner>
</section>
